import React, { createContext, useContext } from 'react';

import type { TargetingTermValue } from '../../../apis/graphql';
import type { TargetingTermDisplayNameLookup } from './Cell/CellItems/TargetingCell/utils';

export type ChangeLogTargetingTermValuesContextValue = {
  displayNameLookup: TargetingTermDisplayNameLookup;
  targetingTermValues: Array<TargetingTermValue> | null;
};

const ChangeLogTargetingTermValuesContext = createContext<ChangeLogTargetingTermValuesContextValue | null>(null);

type Props = Readonly<{
  value: ChangeLogTargetingTermValuesContextValue | null;
  children: React.ReactNode;
}>;

export function ChangeLogTargetingTermValuesProvider({ value, children }: Props): JSX.Element {
  return (
    <ChangeLogTargetingTermValuesContext.Provider value={value}>
      {children}
    </ChangeLogTargetingTermValuesContext.Provider>
  );
}

export function useChangeLogTargetingTermValues(): ChangeLogTargetingTermValuesContextValue | null {
  return useContext(ChangeLogTargetingTermValuesContext);
}
